enum PersistentEndpoints {
    MailRead = 'MailRead',
    MailCompose = 'MailCompose',
    NoEndpoint = '',
}

export default PersistentEndpoints;
